import { ChangeDetectorRef, DestroyRef, Directive, Injector, inject, input } from '@angular/core';

import type { Uuid } from '@common/types';

@Directive()
export abstract class WebBaseViewSignalFormComponent<T extends { id: Uuid }> {
    public readonly widget = input.required<T>();
    public readonly isSpecific = input<boolean>(false);

    protected readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
    protected readonly destroyRef: DestroyRef = inject(DestroyRef);
    protected readonly injector: Injector = inject(Injector);
}
